module.exports = __webpack_public_path__ + "06c72479e706a9e4b214a9f31c0b1436.jpg";